export const NOTIFICATION_TYPES = {
    PUBLISH_SUCCESS: 'publishSuccess',
    PUBLISH_FAILURE: 'publishFailure',
    PLACE_SUCCESS: 'placeSuccess',
    PLACE_ERROR: 'placeError',
    FLIGHT_UPDATE: 'flightUpdate',
    TRANSLATE_START: 'translateStart',
    TRANSLATE_SUCCESS: 'translateSuccess',
    TRANSLATE_ERROR: 'translateError',
    THEME_SUCCESS: 'themeSuccess'
};
